<template>
  <Modal v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">关闭解约协议</div>   
    <p>您确定要关闭该解约协议吗?</p>
    <div slot="footer">
        <Button type="text" @click="cancel">取消</Button>
        <Button type="primary" @click="closeTermination"  :loading="loading">
            <span v-if="!loading">确定</span>
            <span v-else>确定</span>
        </Button>
    </div>
  </Modal> 
</template>
 
<script type="text/ecmascript-6">
import { closeSurrenderProtocol } from 'api/termination'
export default {
  props:{
    n:{
      type:Number,
      default:0
    },
    surrenderFid:{
      type:String,
      default:''
    }
  },
  data () {
    return {
       show:false,
       loading:false
    };
  },
  watch:{
   n(val){
     this.show = true;
   }
 },
  methods:{
    changeLoading() {
      this.loading = false; 
      this.$nextTick(() => {
          this.loading = true
      })
    },
    cancel(){
      this.show = false
    },
    closeTermination(){
      this.loading = true
      if(this.surrenderFid) {
        closeSurrenderProtocol(this.surrenderFid).then( res => {     
          this.$Message.success('关闭成功');
          this.show = false;
          this.loading = false
          this.$emit('refresh')
        })
      }  
   }
  }
}
</script>
